












































import MultiLevelSelect from "@/components/MultiLevelSelect.vue";
import { AgentModuleConfiguration } from "@/models";
import AdcontrolProfile from "@/models/AdcontrolProfile";
import { Component, Prop, Mixins } from "vue-property-decorator";
import { Getter } from "vuex-class";
import MatchProductSelectPrincipalAccordion from "@/components/Agents/MatchProductSelectPrincipalAccordion.vue";
import ClientAgentProduct, {
  ProductWithoutPrincipals,
} from "@/models/Agents/Product";
import MatchPrincipalAccordionTable from "@/components/Agents/MatchPrincipalAccordionTable.vue";
import Product, { AgentProductMixinTags } from "@/mixins/http/Agents/Product";
import ToastInvoker from "@/utils/ToastInvoker";
import { AgentModuleConfigurationMixinTags } from "@/mixins/http/Agencies/AgentModuleConfigurationMixin";

@Component({
  components: {
    MatchPrincipalAccordionTable,
    MultiLevelSelect,
    MatchProductSelectPrincipalAccordion,
  },
})
export default class MatchProductPrincipalAccordion extends Mixins(Product) {
  @Prop() readonly principalCompanyId!: string;
  @Prop() readonly companyName!: string;
  @Prop() readonly agentModuleConfiguration!: AgentModuleConfiguration;

  @Getter("profile") readonly profile!: AdcontrolProfile;

  state: "opened" | "closed" = "closed";
  products: ProductWithoutPrincipals[] = [];
  solvedProductsCounter = 0;
  resolved: true | false = false;

  get uniqueRequestTag(): string {
    return `${AgentProductMixinTags.GetProductsWithoutPrincipals}_company_${this.principalCompanyId}`;
  }

  get loading(): boolean {
    const productsLoading =
      this.$store.getters["http/status"][this.uniqueRequestTag]?.loading ??
      false;

    const agentModuleConfigurationLoading =
      this.$store.getters["http/status"][
        AgentModuleConfigurationMixinTags.GetAgentModuleConfiguration
      ]?.loading ?? false;

    return productsLoading || agentModuleConfigurationLoading;
  }

  onPrincipalProductSolved() {
    if (this.solvedProductsCounter < this.products.length) {
      this.solvedProductsCounter++;
      this.resolved = this.solvedProductsCounter === this.products.length;
    }
  }

  async toggleState() {
    if (this.isResolved()) return;

    if (this.state == "opened" && !this.isResolved()) {
      this.state = "closed";
      return;
    }

    try {
      await this.getProductsWithoutPrincipals(
        this.uniqueRequestTag,
        this.profile.slug,
        {
          "filter[principal_company]": this.principalCompanyId,
          include: "*.principal_agent_company",
          "page[size]": "all",
        }
      ).then((results) => {
        const productMap = new Map<string, ProductWithoutPrincipals>();

        for (const product of results) {
          if (productMap.has(product.name)) {
            productMap.get(product.name)?.products.push(product);
          } else {
            productMap.set(product.name, {
              name: product.name,
              products: [product as ClientAgentProduct],
            });
          }
        }

        this.products = Array.from(productMap.values());
      });
    } catch (error) {
      ToastInvoker.errorToast("Errore durante il caricamento", error);
    } finally {
      this.solvedProductsCounter = 0;
      this.resolved = false;
      this.state = "opened";
    }
  }

  isResolved() {
    return this.resolved;
  }

  hideWhenAllResolved() {
    return this.isResolved() ? "group-resolved" : "";
  }
}
